import { Flex, chakra } from '@chakra-ui/react';
import { NOTIFICATION_FILTERS, type NotificationFilter } from '@/utils/notificationGrouping';

interface FilterChipsProps {
  value: NotificationFilter;
  onChange: (filter: NotificationFilter) => void;
}

export function FilterChips({ value, onChange }: FilterChipsProps) {
  return (
    <Flex
      role="group"
      aria-label="Filter notifications"
      gap="2"
      overflowX="auto"
      // Bleed to the screen edge on mobile so the row visibly scrolls past the gutter.
      mx={{ base: -3, md: 0 }}
      px={{ base: 3, md: 0 }}
      css={{ scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}
    >
      {NOTIFICATION_FILTERS.map(({ key, label }) => {
        const selected = key === value;
        return (
          <chakra.button
            key={key}
            type="button"
            aria-pressed={selected}
            flexShrink={0}
            px="3.5"
            py="7px"
            borderRadius="full"
            border="1px solid"
            borderColor={selected ? 'volyx.primary' : 'volyx.borderLight'}
            bg={selected ? 'volyx.primary' : 'white'}
            color={selected ? 'white' : 'volyx.text'}
            fontSize="14px"
            lineHeight="20px"
            fontWeight="medium"
            whiteSpace="nowrap"
            cursor="pointer"
            transition="background-color 0.15s ease, border-color 0.15s ease"
            _hover={selected ? undefined : { borderColor: 'volyx.mediumGray' }}
            _focusVisible={{ outline: '2px solid', outlineColor: 'volyx.action', outlineOffset: '2px' }}
            onClick={() => onChange(key)}
          >
            {label}
          </chakra.button>
        );
      })}
    </Flex>
  );
}
